module.exports = __webpack_public_path__ + "static/media/logo_chatbot@2x.e5ebdfb6.webp";